import React, {Component} from 'react';
import axios from "axios";
import Pannellum from "pannellum-react/es/elements/Pannellum"
import Slider from "react-slick";
import {Helmet} from "react-helmet";

class Photos360 extends Component {
    constructor(props) {
        super(props);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

        this.getImages = this.getImages.bind(this);
        this.changeImage = this.changeImage.bind(this);

        this.state = {
            imgId: 1,
            imageUrl: '',
            height: 0,
            width: 200,
            pitch: 30,
            vaov: 180,
            images: [],
            selectedImgIndex: 0,
        }
        const csrf = document.head.querySelector('meta[name="csrf-token"]');

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf.content;
        axios.defaults.headers.common['X-localization'] = document.documentElement.lang;

    }

    getImages() {
        axios.get('/api/site/' + this.props.siteID + '/images360', {
            withCredentials: true
        }).then((response) => {
            if (response.data.length) {
                this.setState({
                    images: response.data
                });
                this.changeImageUrl(response.data[0]['url'])
            }

        }).catch((error) => {
            // No images found, this is an imported WP site. Load a different module
        });
    }

    componentDidMount() {

        this.getImages();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.props.toggleMenu('close');

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({width: window.innerWidth, height: window.innerHeight});
    }

    changeImage(imageIndex) {

        this.changeImageUrl(this.state.images[imageIndex]['url'])
    }

    changeImageUrl(url) {
        let img = new Image();
        let self = this;
        img.onload = function () {
            self.setState({
                imageUrl: url,
                vaov: 180 / (this.width / this.height) * 2
            })
        }
        img.src = url;
    }

    render() {

        const {images} = this.state;

        let preview_wrapper_width = '';
        let slidesToShow = 3;

        if (images.length <= 2) {
            preview_wrapper_width = window.innerWidth < 347 ? window.innerWidth + 'px' : '347px';
            slidesToShow = 2;
        } else if (images.length === 3) {
            preview_wrapper_width = window.innerWidth < 486 ? window.innerWidth + 'px' : '486px';
            slidesToShow = 3;
        }

        const settings = {
            slidesToShow: slidesToShow,
            infinite: false,
            responsive: [
                {
                    breakpoint: 791,
                    settings: {
                        slidesToShow: slidesToShow,
                    }
                },
                {
                    breakpoint: 491,
                    settings: {
                        slidesToShow: 1

                    }
                }
            ]
        };

        const preview_wrapper_style = {
            left: '50%',
            width: preview_wrapper_width,
            transform: 'translateX(-50%)'
        }

        return (

            <div className="homepage-wrapper images360-wrapper">
                <Helmet>
                    <link rel="stylesheet" type="text/css" charset="UTF-8"
                          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"/>
                    <link rel="stylesheet" type="text/css"
                          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"/>
                </Helmet>

                <div className="fullscreen-wrapper">
                    <div>

                        <Pannellum
                            width="100%"
                            height={this.state.height + 'px'}
                            image={this.state.imageUrl}
                            pitch={0}
                            yaw={0}
                            vaov={this.state.vaov}
                            hfov={110}
                            autoLoad
                        >
                        </Pannellum>

                    </div>
                </div>
                <div className="preview_wrapper" style={preview_wrapper_style}>
                    <Slider
                        {...settings}
                        swipeToSlide={true}
                        focusOnSelect={false}
                        centerPadding={'1px'}
                        infinite={false}
                        arrows={true}
                        variableWidth={true}
                    >
                        {
                            images.map((image, index) =>
                                <Slide key={index} url={image['url_sm']} index={index}
                                       selectedImgIndex={this.state.selectedImgIndex} changeImage={this.changeImage}/>
                            )
                        }
                    </Slider>
                </div>
            </div>
        )
    }
}

export default Photos360;


const Slide = ({url, changeImage, index, selectedImgIndex}) => (
    <div className="slide-img-wrapper">
        <img key={index}
             className={selectedImgIndex === index ? "small-slider-img active-thumbnail" : "small-slider-img"} src={url}
             onClick={() => changeImage(index)}/>
    </div>
);
